import React from 'react';
import { Loader } from '@gr-monorepo/common/public/ui';
import OlympiadDetails from 'features/olympiads/components/OlympiadDetails';
import { TableTitle } from 'features/olympiads/components/OlympiadDetails/OlympiadDetailsStyled';
import { Olympiad as OlympiadDetailsData, OlympiadStatus as DetailsOlympiadStatus } from 'features/olympiads/model';
import * as S from './OlympiadsStatisticStyled';

const createEmptyOlympiadDetails = (id: string, name = ''): OlympiadDetailsData => ({
  id,
  name,
  ratingByRealStudentsCount: false,
  total: {
    activeStudentsCount: 0,
    participantsPercent: 0,
    participantsCount: 0,
    prizeholdersPercent: 0,
    prizeholdersCount: 0,
    realStudentsCount: null,
  },
  schools: [],
  municipalities: [],
  cards: [],
});

type OlympiadStatisticTableProps = {
  olympiadId: string;
  olympiadName?: string;
  isRegionUser: boolean;
  loading: boolean;
  error: boolean;
  data: OlympiadDetailsData | null;
  status: DetailsOlympiadStatus;
  userType: string;
  largeCity: boolean;
};

const OlympiadStatisticTable = ({
  olympiadId,
  olympiadName,
  isRegionUser,
  loading,
  error,
  data,
  status,
  userType,
  largeCity,
}: OlympiadStatisticTableProps) => {
  const tableTitle = isRegionUser ? 'Статистика по муниципалитетам' : 'Статистика по школам';

  return (
    <>
      <TableTitle>
        <div>{tableTitle}</div>
      </TableTitle>

      {loading ? (
        <S.StatisticTableCard data-testid="olympiad-statistic-table-loader">
          <S.StatisticTableLoader>
            <Loader size={56} />
          </S.StatisticTableLoader>
        </S.StatisticTableCard>
      ) : error ? (
        <S.StatisticTableCard data-testid="olympiad-statistic-table-error">
          <S.StatisticTableMessage>Не удалось загрузить статистику по олимпиаде</S.StatisticTableMessage>
        </S.StatisticTableCard>
      ) : (
        <OlympiadDetails
          tableOnly
          hideTableTitle
          tableWrapper={S.StatisticTableCard}
          data={data ?? createEmptyOlympiadDetails(olympiadId, olympiadName)}
          status={status}
          showRating={false}
          isRegionUser={isRegionUser}
          userType={userType}
          largeCity={largeCity}
        />
      )}
    </>
  );
};

export default OlympiadStatisticTable;